const MAPS = {
  mic: ["...###...", "..#####..", "..#####..", "..#####..", "..#####..", "#..###..#", "#.......#", ".#.....#.", "..#####..", "....#....", "..#####.."],
  arrow: [".....#...", ".....##..", ".....###.", "#########", ".....###.", ".....##..", ".....#..."],
  stop: ["#######", "#######", "#######", "#######", "#######", "#######", "#######"],
};
export function PixelIcon({ kind }: { kind: keyof typeof MAPS }) {
  const rows = MAPS[kind];
  return <svg viewBox={`0 0 ${rows[0].length} ${rows.length}`} className="h-5 w-5" shapeRendering="crispEdges" aria-hidden="true">{rows.flatMap((row, y) => [...row].map((cell, x) => cell === "#" ? <rect key={`${x}-${y}`} x={x} y={y} width="1" height="1" fill="currentColor" /> : null))}</svg>;
}